module.exports = __webpack_public_path__ + "static/media/COS_LOGO_MEDIUM.10e6fcd1.png";